import { IApplicationState } from '../../types/redux';

export function selectIsPrinting(state: IApplicationState): boolean {
  return state.print.isPrinting;
}
